// Azure Blob Storage Service für Team-Bilder

const AZURE_BLOB_CONFIG = {
  storageAccount: "mfprojects",
  containerName: "team-images",
  sasToken: "sv=2024-11-04&ss=b&srt=co&sp=rwdlaciytfx&se=2035-10-02T19:07:10Z&st=2025-10-02T10:52:10Z&spr=https&sig=A8jWH2s8LkqmqiQjwjR8bL4sLjDKgKlE1HkDCZSlsYk%3D"
};

const validateFile = (file) => {
  const maxSize = 5 * 1024 * 1024;
  const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
  
  if (!file) throw new Error("Keine Datei");
  if (!allowedTypes.includes(file.type)) throw new Error("Ungültiges Format");
  if (file.size > maxSize) throw new Error("Max 5MB");
  return true;
};

const resizeImage = (file, maxWidth) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    img.onload = () => {
      let width = img.width;
      let height = img.height;
      
      if (width > maxWidth) {
        const ratio = maxWidth / width;
        width = maxWidth;
        height = height * ratio;
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error("Konvertierung fehlgeschlagen"));
      }, file.type, 0.9);
    };

    img.onerror = () => reject(new Error("Bild nicht ladbar"));
    img.src = URL.createObjectURL(file);
  });
};

const uploadBlob = async (blobPath, blob, contentType) => {
  const url = `https://${AZURE_BLOB_CONFIG.storageAccount}.blob.core.windows.net/${AZURE_BLOB_CONFIG.containerName}/${blobPath}?${AZURE_BLOB_CONFIG.sasToken}`;
  
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "x-ms-blob-type": "BlockBlob",
      "Content-Type": contentType || blob.type
    },
    body: blob
  });

  if (!response.ok) throw new Error(`Upload fehlgeschlagen: ${response.status}`);
  return url.split("?")[0];
};

export const uploadTeamImage = async (teamId, file) => {
  validateFile(file);
  
  const bildId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  const fileExt = file.name.split(".").pop().toLowerCase();
  const urls = {};

  const sizes = [
    { name: "medium", width: 400 },
    { name: "thumbnail", width: 200 }
  ];

  for (const size of sizes) {
    const resizedBlob = await resizeImage(file, size.width);
    const blobPath = `${teamId}/${bildId}/${size.name}.${fileExt}`;
    urls[size.name] = await uploadBlob(blobPath, resizedBlob, file.type);
  }

  return { bildId, urls };
};

export const deleteTeamImage = async (teamId, bildId) => {
  const sizes = ["medium", "thumbnail"];
  
  for (const size of sizes) {
    try {
      const url = `https://${AZURE_BLOB_CONFIG.storageAccount}.blob.core.windows.net/${AZURE_BLOB_CONFIG.containerName}/${teamId}/${bildId}/${size}?${AZURE_BLOB_CONFIG.sasToken}`;
      await fetch(url, { method: "DELETE" });
    } catch (error) {
      console.warn(`Fehler beim Löschen ${size}:`, error);
    }
  }
};